import { NgModule } from '@angular/core';

import { AutoDropDirectionDirective } from './auto-drop-direction.directive';

@NgModule({
    declarations: [AutoDropDirectionDirective],
    exports: [AutoDropDirectionDirective],
})
export class AutoDropDirectionModule {}
